<template>
  <v-container fluid class="grey lighten-3">

    <v-row class="inner-content">
      <v-col>
        <VerticalsTable />
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
export default {
  name: 'Verticals',

  components: {
    VerticalsTable: () => import('@/components/tables/VerticalsTable.vue')
  },
}
</script>
